import React from 'react';
import { Redirect } from 'react-router';

interface RedirectToClientModuleProps {}

const RedirectToClientModule: React.FC<RedirectToClientModuleProps> = props => {
  return <Redirect to="/app/explore" />
}

export default RedirectToClientModule;